import React, {useRef, useEffect, useCallback, useState } from 'react';
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box'; 
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton'; 
import MenuItem  from "@mui/material/MenuItem"; 
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import { warningErrorAction } from "actions/ErrorActions";
import { NumericFormat } from 'components/utils/NumericFormat';
import { helpHttp } from "service/HelpHttp";
import "css/employeeHeader.css";
import "css/customDialog.css"; 
import StoreSearchDrivers from "pages/stores/storeEdit/StoreSearchDrivers";
import PropTypes from 'prop-types'; 

const initialVehicle = {
  "id":"",
  "indexrowvehicle":0,
  "licenseplate" : "",
  "defaultvehicle" : false,
  "tara" : 0,
  "pma" : 0,
  "checkpma" : true, 
  "enabled" : true,
  "vehiclestore_store_id" : 0,
  "vehiclestore_store_tradename" : "",
  "vehiclestore_person_id" : 0,
  "vehiclestore_person_numberdocument" : "",
  "vehiclestore_person_fullname" : "",
 };

const initialDocumentIdToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": ""
}];

const StoreCreateOrEditVehicle = ({openEditRowVehicle,setOpenEditRowVehicle,openEditNewVehicle,setOpenEditNewVehicle,formStore,setFormStore,editRowVehicle,setEditRowVehicle}) => {
  const {t, i18n} = useTranslation(['listDataStores']);
  const token = useSelector((state) => state.loginUser.token); 
  const [newVehicle,setNewVehicle]= useState(initialVehicle);
  const [errorsVehicle, setErrorsVehicle] = useState({});
  const [foundLicensePlate, setFoundLicensePlate ]= useState(false);
  const [showModalSearchDrivers, setShowModalSearchDrivers] = useState(false); 
  const [documentIdDriverToSelect,setDocumentIdDriverToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredDocumentIdDriver, setFilteredDocumentIdDriver] = useState([]); // Opciones filtradas
  const [highlightedIndexDocumentIdDriver, setHighlightedIndexDocumentIdDriver] = useState(-1); // Índice de la opción resaltada 
  const [tradenameDriverToSelect,setTradenameDriverToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredTradenamedDriver, setFilteredTradenamedDriver] = useState([]); // Opciones filtradas
  const [highlightedIndexTradenamedDriver, setHighlightedIndexTradenamedDriver] = useState(-1); // Índice de la opción resaltada 
    
  const dispatch = useDispatch();
 

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openEditRowVehicle) {
        setNewVehicle(initialVehicle);
        setErrorsVehicle({});
        setEditRowVehicle(initialVehicle);
        setOpenEditNewVehicle(false);
        setOpenEditRowVehicle(false);
        setFoundLicensePlate(false);
        setShowModalSearchDrivers(false);
        setDocumentIdDriverToSelect(initialDocumentIdToSelect);
        setFilteredDocumentIdDriver([]);
        setHighlightedIndexDocumentIdDriver(0);
        setTradenameDriverToSelect(initialDocumentIdToSelect);
        setFilteredTradenamedDriver([]);
        setHighlightedIndexTradenamedDriver(-1);  
        
      }
    },[
      setNewVehicle,
      setErrorsVehicle,
      openEditRowVehicle,
      setOpenEditRowVehicle,
      setOpenEditNewVehicle,
      setFoundLicensePlate,
      setShowModalSearchDrivers,
      setDocumentIdDriverToSelect,
      setFilteredDocumentIdDriver,
      setHighlightedIndexDocumentIdDriver,
      setTradenameDriverToSelect,
      setFilteredTradenamedDriver,
      setHighlightedIndexTradenamedDriver,
      setEditRowVehicle]
  );

  const handleCloseNewVehicle = () => {
    setNewVehicle(initialVehicle);
    setErrorsVehicle({});
    setEditRowVehicle(initialVehicle);
    setOpenEditNewVehicle(false);
    setOpenEditRowVehicle(false);
    setFoundLicensePlate(false);
    setShowModalSearchDrivers(false);
    setDocumentIdDriverToSelect(initialDocumentIdToSelect);
    setFilteredDocumentIdDriver([]);
    setHighlightedIndexDocumentIdDriver(0);
    setTradenameDriverToSelect(initialDocumentIdToSelect);
    setFilteredTradenamedDriver([]);
    setHighlightedIndexTradenamedDriver(-1);  
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };
  
  // Dentro del componente
  const debouncedHandleSearchDocumentIdDriver = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
        setFilteredDocumentIdDriver([]);
        setHighlightedIndexDocumentIdDriver(-1);
        return;
    }
    const filtered = documentIdDriverToSelect
        .filter(driver => driver && driver.documentid)
        .filter(driver => {
        const documentid = driver.documentid.toUpperCase();
        return documentid.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
    setFilteredDocumentIdDriver(filtered);
    setHighlightedIndexDocumentIdDriver(0);
  }, 300);
  const handleSelectDocumentIdDriver = (driver) => {
    if (!driver) {
        setNewVehicle((newVehicle) => ({
        ...newVehicle,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument: "",
          vehiclestore_person_fullname: "",
      }));
      return; // Validación adicional para evitar errores
    }
    setNewVehicle((newVehicle) => ({
      ...newVehicle,
      vehiclestore_person_id:driver.id || 0,
      vehiclestore_person_numberdocument: driver.documentid || "",
      vehiclestore_person_fullname: driver.tradename || "",
    }));
    setFilteredDocumentIdDriver([]);
    setHighlightedIndexDocumentIdDriver(-1);
  }; 
  const handleKeyDownDocumentIdDriver = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredDocumentIdDriver.length === 0 && newVehicle.vehiclestore_person_numberdocument.trim() === "") {
        setFilteredDocumentIdDriver(documentIdDriverToSelect);
        setHighlightedIndexDocumentIdDriver(0);
      } else {
        setHighlightedIndexDocumentIdDriver((prevIndex) => {
        const nextIndex = prevIndex < filteredDocumentIdDriver.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDocumentIdDriver((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdDriver >= 0) {
      if (highlightedIndexDocumentIdDriver >= 0 && highlightedIndexDocumentIdDriver < filteredDocumentIdDriver.length) {
        handleSelectDocumentIdDriver(filteredDocumentIdDriver[highlightedIndexDocumentIdDriver]);
      }
    } else if (event.key === "Escape") {
      const isValid = documentIdDriverToSelect.some((driver) => {
      if (!driver || !driver.documentid) return false; 
        const normalizedStoreId = driver.documentid.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputId = newVehicle.vehiclestore_person_numberdocument.toUpperCase();
        return normalizedStoreId === normalizedInputId;
      }); 
      if (!isValid) {
        setNewVehicle((newVehicle) => ({
          ...newVehicle,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument:"",
          vehiclestore_person_fullname: "",
        }));
      } 
      setFilteredDocumentIdDriver([]);
      setHighlightedIndexDocumentIdDriver(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchTradenameDriver= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
        setFilteredTradenamedDriver([]);
        setHighlightedIndexTradenamedDriver(-1);
    return;
    }
    const filtered = tradenameDriverToSelect
    .filter(driver => driver && driver.tradename)
    .filter(driver => {
        const tradename = driver.tradename.toUpperCase();
        return tradename.includes(upperValue);
    })
    .slice(0, 20); // limitar resultados
    setFilteredTradenamedDriver(filtered);
    setHighlightedIndexTradenamedDriver(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectTradeNameDriver = (driver) => {
      if (!driver) {
        setNewVehicle((newVehicle) => ({
        ...newVehicle,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument: "",
          vehiclestore_person_fullname: "",
      }));
      return; // Validación adicional para evitar errores
    }
    setNewVehicle((newVehicle) => ({
      ...newVehicle,
      vehiclestore_person_id:driver.id || 0,
      vehiclestore_person_numberdocument: driver.documentid || "",
      vehiclestore_person_fullname: driver.tradename || "",
    }));
    setFilteredTradenamedDriver([]);
    setHighlightedIndexTradenamedDriver(-1);
  }; 
  const handleKeyDownTradenameDriver = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTradenamedDriver.length === 0 && newVehicle.vehiclestore_person_fullname.trim() === "") {
        setFilteredTradenamedDriver(tradenameDriverToSelect);
        setHighlightedIndexTradenamedDriver(0);
      } else {
        setHighlightedIndexTradenamedDriver((prevIndex) => {
        const nextIndex = prevIndex < filteredTradenamedDriver.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradenamedDriver((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedDriver >= 0) {
      if (highlightedIndexTradenamedDriver >= 0 && highlightedIndexTradenamedDriver < filteredTradenamedDriver.length) {
        handleSelectTradeNameDriver(filteredTradenamedDriver[highlightedIndexTradenamedDriver]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameDriverToSelect.some((driver) => {
        if (!driver || !driver.tradename) return false; 
          const normalizedTradeName = driver.tradename.toUpperCase();
          const normalizedInputTradeName = newVehicle.vehiclestore_person_fullname.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setNewVehicle((newVehicle) => ({
          ...newVehicle,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument:"",
          vehiclestore_person_fullname: "",
        }));
      } 
      setFilteredTradenamedDriver([]);
      setHighlightedIndexTradenamedDriver(-1);
    }
  };

    // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    // Asegúrate de que no se cierra si haces clic en un elemento de la lista
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredDocumentIdDriver([]);
      setHighlightedIndexDocumentIdDriver(-1); 
      setFilteredTradenamedDriver([]);
      setHighlightedIndexTradenamedDriver(-1);
    }
  }, []);
  
  const handleChangeNewVehicle = (e) => {
    const { name, value } = e.target;
    setNewVehicle(newVehicle => ({
      ...newVehicle,
      [name]: value,
    }));   
  };
  
  const handleBlurNewVehicle = (e) => {
    handleChangeNewVehicle(e);
    setErrorsVehicle(validateFormVehicle());
  };
   

  const handleChangeNewVehicleNumber = (e) => {
    const { name, value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll("kg","").replaceAll("€","").replaceAll("%","").replaceAll(" ","")):0;
    setNewVehicle(newVehicle => ({
      ...newVehicle,
      [name]: newValue,
    }));   
  };

  const handleBlurNewVehicleNumber = (e) => {
    handleChangeNewVehicleNumber(e);
    setErrorsVehicle(validateFormVehicle());
  }; 
  
  const handleChangeEnabledDefaultVehicle = () => {
    setNewVehicle(newVehicle => ({
      ...newVehicle,
      defaultvehicle: !newVehicle.defaultvehicle
    }));
  };
  
  const handleChangeEnabledVehicle = () => {
    setNewVehicle(newVehicle => ({
      ...newVehicle,
      enabled: !newVehicle.enabled
    }));
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000) return true;
    return false;
  };

   const searchDRIVER= (event) => { 
    setShowModalSearchDrivers(true);
  };

  const deleteDriver = (event) => {
    setNewVehicle(newVehicle => ({
      ...newVehicle,
      vehiclestore_person_id:0,
      vehiclestore_person_numberdocument:"",
      vehiclestore_person_fullname: ""
    }));
    setErrorsVehicle(validateFormVehicle());
  };

  const toggleDrawerNewVehicle  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseNewVehicle();
    }
  };

  const validateFormVehicle = () => {
    let errorsVehicle = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (newVehicle.licenseplate===""){
        errorsVehicle.licenseplate = 'TextLicensePlateRequired';
    }else{
      if (regexInvalidCharacters.test(formStore.licenseplate)) {
        errorsVehicle.licenseplate = 'Text_TextNoValid';
      } if (foundLicensePlate){
        errorsVehicle.licenseplate='Text_LicensePlateExist_other';
      }
    }
    
    if (!openEditNewVehicle){
      if (formStore.vehicles.find(item => {return (item.licenseplate.trim()=== newVehicle.licenseplate.trim()) })){
        errorsVehicle.licenseplate = 'Text_LicensePlateExist';
      }
    }else{
      if (formStore.vehicles.find((item, index) => {return (item.indexrowvehicle!==newVehicle.indexrowvehicle && item.licenseplate.trim()=== newVehicle.licenseplate.trim()  ) })){
        errorsVehicle.licenseplate = 'Text_LicensePlateExist';
      }
    }  
    
    return errorsVehicle;
  };

  const handleSubmitNewVehicle = () => {   
    setErrorsVehicle(validateFormVehicle());
    let errorsCheckVehicle=validateFormVehicle();

    if ((Object.keys(errorsCheckVehicle).length === 0) 
          && newVehicle.licenseplate!=='' ) {

      let defaultVehicleFound=newVehicle.defaultvehicle;
      
      if (formStore.vehicles.length <=1){
        defaultVehicleFound=true;
      }
      
      let vehicleToAdd={
        "id":newVehicle.id,
        "indexrowvehicle":openEditNewVehicle?newVehicle.indexrowvehicle:formStore.vehicles.length>0?formStore.vehicles[formStore.vehicles.length-1].indexrowvehicle+1:1,       
        "licenseplate":newVehicle.licenseplate,
        "defaultvehicle":defaultVehicleFound,
        "tara":newVehicle.tara,
        "pma":newVehicle.pma,
        "checkpma":newVehicle.checkpma,
        "enabled":newVehicle.enabled,
        "vehiclestore_store_id" : newVehicle.vehiclestore_store_id,
        "vehiclestore_store_tradename" :newVehicle.vehiclestore_store_tradename,
        "vehiclestore_person_id" : newVehicle.vehiclestore_person_id,
        "vehiclestore_person_numberdocument" : newVehicle.vehiclestore_person_numberdocument,
        "vehiclestore_person_fullname" : newVehicle.vehiclestore_person_fullname
      }
      
      if (vehicleToAdd.defaultvehicle){
        formStore.vehicles.map((item)=>{
            return item.defaultvehicle=false  
        })
        setFormStore(formStore => ({
          ...formStore,
        }))
      }
       
      if (!openEditNewVehicle){
        formStore.vehicles.push(vehicleToAdd);
      }else{
        let idx=formStore.vehicles.findIndex(((item) => item.indexrowvehicle === newVehicle.indexrowvehicle));
        formStore.vehicles[idx]=vehicleToAdd
      }
      setFormStore(formStore => ({
        ...formStore,
      }))
      handleCloseNewVehicle();
    } else {
      if (errorsCheckVehicle.licenseplate){
        dispatch(warningErrorAction(t(errorsCheckVehicle.licenseplate)));
      }
      if (errorsCheckVehicle.defaultdriver){
        dispatch(warningErrorAction(t(errorsCheckVehicle.defaultdriver)));
      }
    }  
  };

  useEffect(() => {
      let isMounted = true; 
      const fetchDataDocumentIdDriver = async () => {
          try {
          const getData = await helpHttp().get2(ENDPOINT,`store/getlistdocumentiddriver/`,token,
              (newVehicle.vehiclestore_person_numberdocument!==undefined && newVehicle.vehiclestore_person_numberdocument!==null && newVehicle.vehiclestore_person_numberdocument.replace(/[.\-/\\|]/g, "").trim()!=="")?newVehicle.vehiclestore_person_numberdocument.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              setDocumentIdDriverToSelect(getData); 
          }
          } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
      };   
      if (openEditRowVehicle){
        if (newVehicle.vehiclestore_person_numberdocument && newVehicle.vehiclestore_person_numberdocument.replace(/[.\-/\\|]/g, "").trim()!=="") { 
          fetchDataDocumentIdDriver();
        }
      } else{
        setDocumentIdDriverToSelect(initialDocumentIdToSelect);
      } 
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,newVehicle.vehiclestore_person_numberdocument,openEditRowVehicle]);
  
    useEffect(() => {
      let isMounted = true; 
      const fetchDataTradenameDriver = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`store/getlisttradenamedriver/`,token,
              (newVehicle.vehiclestore_person_fullname!==undefined && newVehicle.vehiclestore_person_fullname!==null && newVehicle.vehiclestore_person_fullname.replace(/[.\-/\\|]/g, "").trim()!=="")?newVehicle.vehiclestore_person_fullname.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              setTradenameDriverToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      };  
      if ( openEditRowVehicle){
        if (newVehicle.vehiclestore_person_fullname && newVehicle.vehiclestore_person_fullname.replace(/[.\-/\\|]/g, "").trim()!=="") { 
          fetchDataTradenameDriver();
        }
      } else{
        setTradenameDriverToSelect(initialDocumentIdToSelect);
      }  
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,newVehicle.vehiclestore_person_fullname,openEditRowVehicle]);
   

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistLicensePlate = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `store/getexixtslicenseplate/`, token,newVehicle.licenseplate);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setFoundLicensePlate(getData!==newVehicle.id && getData>0)
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (newVehicle.licenseplate!==""){
      fetchExistLicensePlate();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,newVehicle.id,newVehicle.licenseplate]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted && openEditNewVehicle){
      setNewVehicle(newVehicle => ({
        ...newVehicle,
        id:editRowVehicle.id!==null?editRowVehicle.id:"",
        indexrowvehicle:editRowVehicle.indexrowvehicle!==null?editRowVehicle.indexrowvehicle:"",
        licenseplate:editRowVehicle.licenseplate!==null?editRowVehicle.licenseplate:"",
        defaultvehicle:editRowVehicle.defaultvehicle!==null?editRowVehicle.defaultvehicle:false,
        tara:editRowVehicle.tara!==null?editRowVehicle.tara:0,
        pma:editRowVehicle.pma!==null?editRowVehicle.pma:0,
        checkpma:editRowVehicle.checkpma!==null?editRowVehicle.checkpma:true,
        defaultdriver:editRowVehicle.defaultdriver!==null?editRowVehicle.defaultdriver:"",
        enabled:editRowVehicle.enabled!==null?editRowVehicle.enabled:true,
        vehiclestore_store_id : editRowVehicle.vehiclestore_store_id!==null?editRowVehicle.vehiclestore_store_id:0,
        vehiclestore_store_tradename : editRowVehicle.vehiclestore_store_tradename!==null?editRowVehicle.vehiclestore_store_tradename:"",
        vehiclestore_person_id : editRowVehicle.vehiclestore_person_id!==null?editRowVehicle.vehiclestore_person_id:0,
        vehiclestore_person_numberdocument : editRowVehicle.vehiclestore_person_numberdocument!==null?editRowVehicle.vehiclestore_person_numberdocument:"",
        vehiclestore_person_fullname : editRowVehicle.vehiclestore_person_fullname!==null?editRowVehicle.vehiclestore_person_fullname:""
      }));
    }
    return()=>{isMounted=false;}   
  },[editRowVehicle,openEditNewVehicle]);

  return(
    <>
      {openEditRowVehicle && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerNewVehicle(false)}
            onOpen={toggleDrawerNewVehicle(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '500px' }}>
                <br/>
                <div id="myDIV">
                  <h1 className="h1NewStyle px-4 mb-2">{openEditNewVehicle?t('Text_Vehicle_Edit'):t('Text_Vehicle_New')}</h1>
                </div>  
                <hr className="sidebar-divider d-none d-md-block"/>
                <form className="createVehicle" onSubmit={handleCloseNewVehicle}>  
                  <div className="form-floating mb-3 px-4 primary">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_licenseplate')} :</label>
                    <div className="form-group">
                      <TextField
                        id="licenseplate" 
                        name="licenseplate"
                        value={newVehicle.licenseplate}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: 450, fontSize: '18px'}, maxLength: 50 }} 
                        label={errorsVehicle.licenseplate!=null?t(errorsVehicle.licenseplate):t('PlaceHolder_Vehicle_licenseplate')}
                        placeholder={t('PlaceHolder_Vehicle_licenseplate')}
                        variant="standard"
                        onBlur={handleBlurNewVehicle}
                        onChange={handleChangeNewVehicle}/>
                    </div>
                    <div className="form-group">
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_defaultvehicle')} :</label>
                      <Checkbox  
                        checked={newVehicle.defaultvehicle} 
                        onChange={handleChangeEnabledDefaultVehicle} 
                        sx={{
                          '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
                        }}
                      />
                    </div>
                    
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_tara')} :</label>
                    <div className="form-group">
                      <NumericFormat 
                        thousandSeparator={','} 
                        decimalSeparator={'.'} 
                        decimalScale= {2}
                        fixedDecimalScale= {true}
                        allowNegative= {false}
                        isAllowed={withValueCap}
                        id="tara" 
                        name="tara"
                        suffix={" kg"}
                        value={newVehicle.tara}
                        className="numeric-field"
                        onBlur={handleBlurNewVehicleNumber}
                        onChange={handleChangeNewVehicleNumber}
                      />  
                    </div>

                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_pma')} :</label>
                    <div className="form-group">
                      <NumericFormat 
                        thousandSeparator={','} 
                        decimalSeparator={'.'} 
                        decimalScale= {2}
                        fixedDecimalScale= {true}
                        allowNegative= {false}
                        isAllowed={withValueCap}
                        id="pma" 
                        name="pma"
                        suffix={" €"}
                        value={newVehicle.pma}
                        className="numeric-field"
                        onBlur={handleBlurNewVehicleNumber}
                        onChange={handleChangeNewVehicleNumber}
                      />
                    </div> 
                     <div className="form-group">
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_enabled')} :</label>
                      <Checkbox  
                        checked={newVehicle.enabled} 
                        onChange={handleChangeEnabledVehicle} 
                        sx={{
                          '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
                        }}
                      />
                    </div>
                    <h6 className="h7NewStyle mb-2">{t('Text_Vehicle_DRIVER').toUpperCase()}&nbsp;:&nbsp;&nbsp; &nbsp;&nbsp;
                      <IconButton  size="small"  className="deletesmall-select-button"  onClick={deleteDriver}>
                        <DeleteIcon style={{fontSize: 28}}/>
                      </IconButton>    
                      &nbsp;&nbsp;
                      <IconButton  size="small"  className="edit-select-button"  onClick={searchDRIVER}>
                        <SearchIcon style={{fontSize: 28}}/>
                      </IconButton>
                    </h6>
                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_documentid').toUpperCase()} :</label>
                    <div className="form-group">
                      <div style={{ position: "relative" }}>
                        <TextField
                          id="vehiclestore_person_numberdocument"
                          name="vehiclestore_person_numberdocument"
                          value={newVehicle.vehiclestore_person_numberdocument}
                          onChange={(e) => {
                            setNewVehicle(prev => ({
                              ...prev,
                              vehiclestore_person_numberdocument: e.target.value.toUpperCase()
                              }));
                              debouncedHandleSearchDocumentIdDriver(e.target.value);
                          }}
                          onKeyDown={handleKeyDownDocumentIdDriver}
                          onBlur={(event) => {
                              if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                              handleBlur();
                              }
                          }}
                          label={errorsVehicle.vehiclestore_person_numberdocument!=null && errorsVehicle.vehiclestore_person_numberdocument!==""?t(errorsVehicle.vehiclestore_person_numberdocument):t('Text_documentid')}
                          placeholder={t('Text_documentid')}
                          variant="standard"
                          fullWidth
                          inputProps={{ style: { fontSize: '18px', }, maxLength: 100 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                      />  
                      {/* Desplegable dinámico */}
                      {filteredDocumentIdDriver.length > 0 && (
                        <div
                          className="dropdown-class"
                          style={{
                            position: "absolute",
                            left:'0px',
                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                            borderRadius: "4px",
                            marginTop: "4px",
                            maxHeight: "200px",
                            overflowY: "auto",
                            width: "100%", 
                            fontSize: '18px',
                            backgroundColor: "#f8f9fa", // Fondo gris claro
                            zIndex: 1000,
                          }}
                          onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                        >
                          {filteredDocumentIdDriver.map((driver, index) => (
                            <MenuItem
                              key={driver.id}
                              onClick={() => handleSelectDocumentIdDriver(driver)}
                              style={{
                                cursor: "pointer",
                                padding: "8px",
                                borderBottom: "1px solid #eee",
                                fontSize: '18px',
                                backgroundColor:
                                index === highlightedIndexDocumentIdDriver ? "#4e73df" : "transparent",
                                color: index === highlightedIndexDocumentIdDriver ? "white" : "black",
                              }}
                            >
                              {driver.documentid} - {driver.tradename}
                            </MenuItem>
                          ))}
                        </div>
                      )}
                      </div>
                    </div>
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_driver').toUpperCase()} :</label>
                    <div className="form-group">
                      <div style={{ position: "relative" }}>
                        <TextField
                          id="vehiclestore_person_fullname"
                          name="vehiclestore_person_fullname"
                          value={newVehicle.vehiclestore_person_fullname}
                          onChange={(e) => {
                            setNewVehicle(prev => ({
                              ...prev,
                              vehiclestore_person_fullname: e.target.value.toUpperCase()
                            }));
                            debouncedHandleSearchTradenameDriver(e.target.value);
                          }}
                          onKeyDown={handleKeyDownTradenameDriver}
                          onBlur={(event) => {
                              if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                              handleBlur();
                              }
                          }}
                          label={errorsVehicle.vehiclestore_person_fullname!=null && errorsVehicle.vehiclestore_person_fullname!==""?t(errorsVehicle.vehiclestore_person_fullname):t('PlaceHolder_Vehicle_driver')}
                          placeholder={t('PlaceHolder_Vehicle_driver')}
                          variant="standard"
                          fullWidth
                          inputProps={{ style: {fontSize: '18px', }, maxLength: 100 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />
                        {/* Desplegable dinámico */}
                        {filteredTradenamedDriver.length > 0 && (
                          <div
                            className="dropdown-class"
                            style={{
                            position: "absolute",
                            left:'0px',
                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                            borderRadius: "4px",
                            marginTop: "4px",
                            maxHeight: "200px",
                            overflowY: "auto",
                            width: "100%", 
                            fontSize: '18px',
                            backgroundColor: "#f8f9fa", // Fondo gris claro
                            zIndex: 1000,
                            }}
                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                          >
                            {filteredTradenamedDriver.map((driver, index) => (
                              <MenuItem
                                  key={driver.id}
                                  onClick={() => handleSelectTradeNameDriver(driver)}
                                  style={{
                                      cursor: "pointer",
                                      padding: "8px",
                                      borderBottom: "1px solid #eee",
                                      fontSize: '18px',
                                      backgroundColor:
                                      index === highlightedIndexTradenamedDriver ? "#4e73df" : "transparent",
                                      color: index === highlightedIndexTradenamedDriver ? "white" : "black",
                                  }}
                              >
                                  {driver.tradename} - {driver.documentid}
                              </MenuItem>
                            ))}
                          </div>
                        )}
                      </div> 
                    </div>     
                    <hr className="sidebar-divider d-none d-md-block" />
                    <div className="formdi-pending-action-group">
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitNewVehicle}>
                        {openEditNewVehicle?t('Button_Update'):t('Button_Create')}
                      </button> 
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseNewVehicle}>
                        {t('Button_Cancel')}
                      </button>
                    </div>  
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>
          <StoreSearchDrivers
            showModalSearchDrivers={showModalSearchDrivers}
            setShowModalSearchDrivers={setShowModalSearchDrivers}
            setNewVehicle={setNewVehicle}
          />  
        </div>
      }   
    </>
  )
}

StoreCreateOrEditVehicle.propTypes = {

  openEditRowVehicle: PropTypes.bool.isRequired,
  setOpenEditRowVehicle: PropTypes.func.isRequired,
  openEditNewVehicle: PropTypes.bool.isRequired,
  setOpenEditNewVehicle: PropTypes.func.isRequired,
  formStore: PropTypes.object.isRequired,
  setFormStore: PropTypes.func.isRequired,
  setEditRowVehicle: PropTypes.func.isRequired
};

export default StoreCreateOrEditVehicle;